import axiosClient from '../configs/axios.js';

class EmptyCylindercolllection {
  
    async getEmptyCylinderList(params) {
        try {
            const response = await axiosClient.get(
                `reports/EmptyCollection`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching cylinder list:', error);
            throw error;
        }
    }

    
}

export default new EmptyCylindercolllection();